import axios from "axios";
import { getBaseUrl, fetchCSRFToken } from "./urlUtils";
import { redirectToLogin, redirectToLogout } from "./authRedirect";
import { csrfTokenHeader } from "../../runtimeConfig";

const isDev = process.env.NODE_ENV === "development";

const pubClient = axios.create({
  baseURL: getBaseUrl(), // Hardcode backend URL for dev
  withCredentials: true,
});

pubClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Clear any stored auth data
      localStorage.clear();

      // Leave public pages (login, sign-up, password reset) where they are:
      // a 401 there is expected, not an expired session.
      redirectToLogin();
      return Promise.reject(error);
    }
    return Promise.reject(error);
  },
);

// Request interceptor to add CSRF token
pubClient.interceptors.request.use(
  async (config) => {
    if (config.method !== "get") {
      const token = await fetchCSRFToken();
      if (token) {
        config.headers[csrfTokenHeader()] = token;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export const logout = async () => {
  try {
    await pubClient.post("/common/logout");
  } catch (error) {
    console.error("Logout failed:", error);
  }
  localStorage.clear();
  redirectToLogout();
};

// Export a function to reinitialize the client with updated config
export const reinitializePubClient = () => {
  pubClient.defaults.baseURL = isDev ? "" : getBaseUrl();
};

export default pubClient;
